/* unplugin-vue-components disabled */import { ElTag as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/tag/style/css';
import { ElButton as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElForm as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import __unplugin_components_0 from '/drone/src/packages/base/src/components/GameChannelSelect/index.vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, createSlots as _createSlots, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "text-right marginB10"
};
import { apiUsdkBatchGetGameInfo, apiUsdkThirdSdkPermissionList } from '@/api/usdk';
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseSwitchCommon, UseDefaultAgreement } from './hooks'; // UseUploadText
import BaseRoot from './modules/baseRoot.vue';
import SetAgreement from './modules/setAgreement.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'agreement',
  setup(__props) {
    const slotColumns = [{
      label: '隐私协议',
      prop: 'priAgrUrl',
      slot: 'priAgrUrl'
    }, {
      label: '用户协议',
      prop: 'userAgrUrl',
      slot: 'userAgrUrl'
    }, {
      label: '儿童协议',
      prop: 'childAgrUrl',
      slot: 'childAgrUrl'
    }, {
      label: '平台协议',
      prop: 'sdkAgrUrl',
      slot: 'sdkAgrUrl'
    }, {
      label: '注销协议',
      prop: 'woffAgrUrl',
      slot: 'woffAgrUrl'
    }];
    const columns = [{
      label: '渠道ID',
      prop: 'cid'
    }, {
      label: '渠道',
      prop: 'cname'
    }, {
      label: '协议弹窗',
      prop: 'status_14',
      slot: 'status_14'
    }, ...slotColumns, {
      label: '操作',
      action: true,
      width: '180'
    }];
    const getUrl = (item, key) => {
      if (item) {
        try {
          const obj = JSON.parse(item);
          return obj[key];
        } catch (e) {
          return '-';
        }
      } else {
        return '-';
      }
    };
    const {
      tableData,
      tableLoading,
      gid,
      filter,
      getTableData,
      switchType
    } = UseSwitchCommon();
    // 获取权限列表
    const permissionList = ref([]);
    const getPermissionList = () => {
      apiUsdkThirdSdkPermissionList({
        gid
      }).then(res => {
        if (res.code === 0) {
          permissionList.value = res.data;
        }
      });
    };
    // 获取游戏信息
    const sdkGameInfo = ref(null);
    watch(() => gid, val => {
      if (val) {
        apiUsdkBatchGetGameInfo({
          gids: val
        }).then(res => {
          if (res.code == 0 && res.data.length) {
            sdkGameInfo.value = res.data[0];
          }
        });
        getPermissionList();
      }
    }, {
      immediate: true
    });
    // 基础权限配置
    const baseRoot = ref();
    const handleRootClick = () => {
      baseRoot.value.show();
    };
    const setAgreement = ref();
    const {
      keyDict
    } = UseDefaultAgreement();
    // const { batchUploadCdnText } = UseUploadText();
    // 批量操作
    const handleBatch = type => {
      if (type === 'version') {// 批量提升版本号
        // 删除此功能 2023-04-06 博川的需求
        // ElMessageBox.confirm('是否确认批量提升版本号？', '提示',{ type: 'warning' }).then(() => {
        // 	const cids = tableSelected.value.map(item => item.cid);
        // 	apiUsdkBatchUpdateAgreementsVersion({
        // 		gid: gid,
        // 		cids: cids.join(',')
        // 	}).then(res => {
        // 		if (res.code === 0) {
        // 			getTableData(() => {
        // 				batchUploadCdnText(cids, gid, sdkGameInfo.value.productID);
        // 			});
        // 		}
        // 	});
        // });
      } else {
        setAgreement.value.show({
          typeTitle: type,
          type: 'batch'
        });
      }
    };
    const handleClick = (type, scope) => {
      let setRoot = type === 'setRoot';
      const row = scope.row;
      console.log('row', row);
      let form = {
        cid: row.cid,
        switch: 0,
        loginProtocol: 0,
        condition: {},
        swPermission: 0,
        conditions: {
          andOr: '&&',
          conditions: [{
            dimension: 'version',
            symbol: undefined,
            value: ''
          }]
        },
        p: [],
        version: 0
      };
      let cname = row.cname;
      let condition = row.condition_14 ? JSON.parse(row.condition_14) : {};
      form.switch = switchType(row.status_14, 14).open;
      // 添加登录协议开关 2023-04-06
      form.loginProtocol = switchType(row.status_20, 20).open;
      form.condition = condition;
      keyDict.forEach(key => {
        if (key === 'swPermission') {
          form.swPermission = condition.swPermission || 0;
        } else {
          form[key] = condition[key] || '';
        }
      });
      if (!form.conditions || !(form.conditions.conditions && form.conditions.conditions.length)) {
        form.conditions = {
          andOr: '&&',
          conditions: [{
            dimension: 'version',
            symbol: undefined,
            value: ''
          }]
        };
      }
      form.p = condition.p && condition.p.split(',').map(item => Number(item));
      // let oldVersion = form.version || 0;
      setAgreement.value.show({
        form,
        // oldVersion,
        setRoot,
        cname,
        type,
        channel: row.channel
      });
    };
    // 表格选择
    const tableSelected = ref([]);
    const hasSelected = computed(() => {
      return !!tableSelected.value.length;
    });
    const handleMultipleSelect = selected => {
      tableSelected.value = selected;
    };
    return (_ctx, _cache) => {
      const _component_game_channel_select = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_form = __unplugin_components_2;
      const _component_el_button = __unplugin_components_3;
      const _component_el_tag = __unplugin_components_4;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", null, [_createVNode(_component_el_form, null, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "选择渠道"
        }, {
          default: _withCtx(() => [_createVNode(_component_game_channel_select, {
            modelValue: _unref(filter).cid,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(filter).cid = $event),
            clearable: "",
            gid: _unref(gid),
            onChange: _unref(getTableData)
          }, null, 8, ["modelValue", "gid", "onChange"])]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
        onClick: handleRootClick,
        class: "marginL10",
        type: "primary"
      }, {
        default: _withCtx(() => [_createTextVNode("基础权限库")]),
        _: 1
      }), _createVNode(_component_el_button, {
        disabled: !_unref(hasSelected),
        onClick: _cache[1] || (_cache[1] = $event => handleBatch('switch')),
        class: "marginL10",
        type: "primary"
      }, {
        default: _withCtx(() => [_createTextVNode("批量控制开关")]),
        _: 1
      }, 8, ["disabled"]), _createVNode(_component_el_button, {
        disabled: !_unref(hasSelected),
        onClick: _cache[2] || (_cache[2] = $event => handleBatch('agreement')),
        class: "marginL10",
        type: "primary"
      }, {
        default: _withCtx(() => [_createTextVNode("批量配置协议")]),
        _: 1
      }, 8, ["disabled"])]), _createVNode(UTable, {
        options: columns,
        "row-key": "cid",
        data: _unref(tableData),
        loading: _unref(tableLoading),
        onMultipleSelect: handleMultipleSelect,
        isMultiple: "",
        pagination: ""
      }, _createSlots({
        status_14: _withCtx(({
          scope
        }) => [_createVNode(_component_el_tag, {
          type: _unref(switchType)(scope.row.status_14, 14).type
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(switchType)(scope.row.status_14, 14).text), 1)]),
          _: 2
        }, 1032, ["type"])]),
        action: _withCtx(({
          scope
        }) => [_createVNode(_component_el_button, {
          link: "",
          type: "primary",
          onClick: $event => handleClick('set', scope)
        }, {
          default: _withCtx(() => [_createTextVNode("协议配置")]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          link: "",
          type: "primary",
          onClick: $event => handleClick('setRoot', scope)
        }, {
          default: _withCtx(() => [_createTextVNode("权限配置")]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 2
      }, [_renderList(slotColumns, item => {
        return {
          name: item.slot,
          fn: _withCtx(({
            scope
          }) => [_createTextVNode(_toDisplayString(getUrl(scope.row.condition_14, item.prop)), 1)])
        };
      })]), 1032, ["data", "loading"])]), _createVNode(BaseRoot, {
        ref_key: "baseRoot",
        ref: baseRoot,
        gid: _unref(gid),
        sdkGameInfo: _unref(sdkGameInfo)
      }, null, 8, ["gid", "sdkGameInfo"]), _createVNode(SetAgreement, {
        ref_key: "setAgreement",
        ref: setAgreement,
        gid: _unref(gid),
        sdkGameInfo: _unref(sdkGameInfo),
        permissionList: _unref(permissionList),
        cids: _unref(tableSelected).map(item => item.cid),
        tableSelected: _unref(tableSelected),
        onOk: _unref(getTableData)
      }, null, 8, ["gid", "sdkGameInfo", "permissionList", "cids", "tableSelected", "onOk"])], 64);
    };
  }
});